
<script>
import { rexRoundedSingleSelect } from '@/components/views/rexRoundedField'
import PopupPenalties from '@/components/views/penalties/PopupPenalties.vue'

export default {
  name: 'cancel-insurance-form',
  components: {
    PopupPenalties,
    rexRoundedSingleSelect
  },
  props: {
    cancelInsuranceIndex: {
      type: Number,
      required: true
    }
  },
  data: () => ({
    insurances: [
      {
        slug: null,
        name: 'Страховка от невыезда не требуется'
      },
      {
        slug: 100,
        name: 'Страховка от невыезда 5% (+ стоим. тура * 0,05 руб)'
      },
    ],
  }),
  computed: {
    getNumberOfTourists() {
      return this.$store.getters['cart/getNumberOfTourists'].total
    },
    getCartPrice() {
      return this.$store.getters['cart/getCartPrice'].amount
    },
    sumPerPerson() {
      return this.getCartPrice / this.getNumberOfTourists
    },
    getInsurance() {
      return this.$store.getters['cart/getInsurance'](this.cancelInsuranceIndex)
    },
  },
  watch: {
    'getCartPrice'() {
      this.setPrice()
    }
  },
  created() {
    this.setPrice()
  },
  methods: {
    setPrice() {
      const price = (this.getCartPrice * 0.05).toFixed(2)

      this.$store.commit('cart/updateServiceField', {
        target: 'cancelInsurance.form.sumPerPerson',
        value: parseFloat(this.sumPerPerson)
      })

      this.insurances[1] = {
        slug: parseFloat(this.sumPerPerson),
        name: `Страховка от невыезда 5% (+ ${price} ${this.getInsurance.current.price.currency})`
      }
    }
  }
}
</script>

<template>
  <div class="cart__insurance--tourist cart__insurance-tourist">
    <div class="cart__insurance-tourist--form cart__insurance-tourist-form">
      <div class="cart__insurance-tourist-form--content full-width">
        <div class="cart__search-form--row">
          <rex-rounded-single-select
            label="Страховка"
            store-module="cart"
            getter-name="getServiceField"
            setter-name="updateServiceField"
            :target="`cancelInsurances.${cancelInsuranceIndex}.form.sumPerPerson`"
            css-class="cart__search-form--cancel-insurance"
            :data="insurances"
          />
          <div class="cart__penalties">
            <popup-penalties
              :ids="{
                insuranceSearchId: getInsurance.searchId,
                insuranceResultId: getInsurance.current.slug,
                currency: getInsurance.current.price.currency,
                sumPerPerson
              }"
              store-module="cart"
              service-name="cancelInsurances"
              :target="`cancelInsurances.${cancelInsuranceIndex}`"
              api-module-name="cancelInsurances"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
